import { render, staticRenderFns } from "./KeyboardTrigger.vue?vue&type=template&id=51184077&"
import script from "./KeyboardTrigger.vue?vue&type=script&lang=js&"
export * from "./KeyboardTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports